export const constants = {
  DOMAIN_URL: 'https://cab-booking.dev.seraphic.io/',
  //   DOMAIN_URL: 'http://localhost:4501/',
  GOOGLE_API: 'AIzaSyBwNVESiHx7F-lDlKEh7dd6NKswCwLyo-I',
};
